import React from 'react';
import { Spinner } from "@chakra-ui/core";
import { Icon } from '../icon';

export const SelectedFile = ({ name, fileId, removeFile, subText, full, isLoading, isRemoving }) => {
  return (
    <div data-testid='file-uploaded' className={`upload-button--has-file ${!full && 'push-half--bottom'} ${isRemoving && 'transparent'}`} key={name}>
      <div className='upload-button__body'>
        <span className="upload-button--text">{name}</span>
        {subText && <span className="upload-button--text upload-button--subtext">{subText}</span>}
      </div>
      {isRemoving ? <div className='flex flex--align-center'><Spinner size="sm" /></div> : (
        <button
          className={isLoading? 'transparent' : ''}
          type="button"
          data-testid='remove-file-btn'
          onClick={() => removeFile(fileId)}
          disabled={isLoading}>
          <Icon name="close" />
        </button>
      )}
    </div>
  )
};